import { useCallback, useState } from 'react';

export const useCollapse = (initialState = false) => {
    const [isCollapsed, setIsCollapsed] = useState(initialState);
    const collapse = useCallback(() => setIsCollapsed(!isCollapsed), [isCollapsed]);

    return [isCollapsed, collapse];
};
